import { render } from "./Instructors.vue?vue&type=template&id=dde445c8&scoped=true"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"

import "./Instructors.vue?vue&type=style&index=0&id=dde445c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde445c8"]])

export default __exports__